import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15 17.49a4.1 4.1 0 0 0-4.097 4.098v3.806H5.594V12.097L15 4.813l9.403 7.284v13.297h-5.306v-3.806A4.1 4.1 0 0 0 15 17.49m10.697-6.42L15.49 3.165a.806.806 0 0 0-.982 0L4.303 11.07a.82.82 0 0 0-.315.64v14.488c0 .428.378.803.803.803h6.915a.824.824 0 0 0 .803-.803v-4.61a2.464 2.464 0 0 1 2.49-2.49 2.463 2.463 0 0 1 2.488 2.49v4.61c0 .428.379.803.807.803h6.915a.824.824 0 0 0 .803-.803V11.71a.82.82 0 0 0-.316-.64"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }